module.exports = __webpack_public_path__ + "2deda0a7b150de67e2776ab51e2d3ccc.png";